interface Props {
  readonly description: string;
}
export function ErrorNotif(props: Readonly<Props>) {
  return (
    <div className="px-4 py-2 border bg-[#FEE4E2] border-[#FDA29B] rounded-lg flex justify-start items-center gap-4 font-normal text-xs md:text-sm text-[#D92D20]">
      <svg
        width="32"
        height="29"
        viewBox="0 0 32 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.55012 27.8337C3.96851 27.8337 1.78987 26.1275 1.10442 23.7932C0.81182 22.7967 1.17135 21.7588 1.72126 20.8751L11.1711 3.83537C13.3852 0.277531 18.6148 0.277536 20.8289 3.83537L30.2787 20.8751C30.8287 21.7588 31.1882 22.7967 30.8956 23.7932C30.2101 26.1275 28.0315 27.8337 25.4499 27.8337H6.55012Z"
          fill="#D92D20"
        />
        <path
          d="M16 16.0004V8.52444M16 21.5416V21.6073M25.4499 27.8337H6.55012C3.96851 27.8337 1.78987 26.1275 1.10442 23.7932C0.81182 22.7967 1.17135 21.7588 1.72126 20.8751L11.1711 3.83537C13.3852 0.277531 18.6148 0.277536 20.8289 3.83537L30.2787 20.8751C30.8287 21.7588 31.1882 22.7967 30.8956 23.7932C30.2101 26.1275 28.0315 27.8337 25.4499 27.8337Z"
          stroke="#FECDCA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-justify w-50 md:w-75">{props.description}</span>
    </div>
  );
}
